import { Controller } from "stimulus";
import { track } from '../analytics';

export default class extends Controller {
    trackSearch() {
        track('Search')
    }
}
